import { Avatar } from '@/components';
import { UserOutlined } from '@ant-design/icons';
import type { FC, ReactNode } from 'react';

type Props = {
  iconUrl?: ReactNode;
  size?: number;
};
export const AccountAvatar: FC<Props> = ({ iconUrl, size = 32 }) => {
  return (
    <Avatar
      {...(iconUrl
        ? {
            src: iconUrl,
          }
        : {
            icon: <UserOutlined />,
          })}
      size={size}
    />
  );
};
